import { render } from "./SuitabilityForm.vue?vue&type=template&id=566cf8b6"
import script from "./SuitabilityForm.vue?vue&type=script&lang=js"
export * from "./SuitabilityForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__